import { IBrand } from '@northladder/services';

import { ICategoryItemRaw, IBidCategoryFiltersData, IBrandRaw } from '../types';

/**
 * this transformer function transforms the raw brands data of category to
 * extract fields that is being consumed by the UI.
 */
function formatBrands(brands: IBrandRaw[]): IBrand[] {
  const formattedBrandList = brands.map((brandItem) => {
    const {
      name,
      name_ar: nameAr,
      name_de: nameDe,
      name_es: nameEs,
      name_fr: nameFr,
      name_he: nameHe,
      name_nl: nameNl,
      name_ro: nameRo,
      name_pl: namePl,
      _id,
    } = brandItem;
    return {
      name: {
        ar: nameAr ?? name,
        de: nameDe ?? name,
        en: name,
        es: nameEs ?? name,
        fr: nameFr ?? name,
        he: nameHe ?? name,
        ro: nameRo ?? name,
        nl: nameNl ?? name,
        pl: namePl ?? name,
      },
      id: _id,
      nameStr: name,
    };
  });

  return formattedBrandList;
}

/**
 * this transformer function transforms the raw category data coming from api
 * according to what ui needs.
 */
export function formatBidCategory(
  data: ICategoryItemRaw[]
): IBidCategoryFiltersData {
  const formattedCategoryList = data.map((category) => {
    const {
      _id,
      bidCount,
      brands,
      categoryName,
      categoryName_ar: categoryNameAr,
      categoryName_es: categoryNameEs,
      categoryName_de: categoryNameDe,
      categoryName_fr: categoryNameFr,
      categoryName_he: categoryNameHe,
      categoryName_nl: categoryNameNl,
      categoryName_ro: categoryNameRo,
      categoryName_pl: categoryNamePl,
      imageUrl,
      priority,
    } = category;

    return {
      id: _id,
      bidCount,
      brands: formatBrands(brands),
      categoryName: {
        ar: categoryNameAr || categoryName,
        de: categoryNameDe || categoryName,
        en: categoryName,
        es: categoryNameEs || categoryName,
        fr: categoryNameFr || categoryName,
        he: categoryNameHe || categoryName,
        nl: categoryNameNl || categoryName,
        ro: categoryNameRo || categoryName,
        pl: categoryNamePl || categoryName,
      },
      categoryNameStr: categoryName,
      imageUrl,
      priority,
      value: categoryName,
    };
  });

  return {
    categoryList: formattedCategoryList,
  };
}
